import React from 'react';
import { Mutation } from 'react-apollo';

import ArrowRight from './arrow-right-24.png';
import { ADD_MESSAGE } from '../../../../query/queries';

import styles from './NewMessage.css';

const NewMessage = class NewMessage extends React.Component {
  state = {
    message: '',
  }

  updateMessage = (event) => {
    const message = event.target.value;
    this.setState({
      message,
    });
  }

  sendMessage = (createMessage) => {
    const text = this.state.message.trim();
    if (text) {
      const date = new Date();
      const from = this.props.props.user.username;
      const to = this.props.props.receiver.username;
      try{
        createMessage({ variables: { text, date, from, to } });
        this.setState({ message: '' });
      } catch(error) {
        alert('OH NO! Ha ocurrido un error. Intentelo de nuevo por favor')
      }     
    }
  }

  handleKeyPressed = (e, createMessage) => {
    if (e.key === 'Enter'){
      this.sendMessage(createMessage);
    }
  }

  render() {
    let buttonTheme, messageAreaTheme = '';
    if (this.props.props.theme === 'DARK'){
      buttonTheme = styles.buttonDarkTheme;
      messageAreaTheme = styles.MessageAreaDarkTheme;
    }
    return (
      (this.props.props.receiver &&
        <Mutation mutation={ADD_MESSAGE}>
          {createMessage => (
            <div className={styles.mainContainer}>
              <textarea className={[styles.messageArea, messageAreaTheme].join(' ')}
                value={this.state.message}
                onChange={e => this.updateMessage(e)}
                onKeyPress={e => {this.handleKeyPressed(e, createMessage)}}
                >
                {this.state.message}
              </textarea>
              <button className={[styles.button, buttonTheme].join(' ')} onClick={() => this.sendMessage(createMessage)}>
                <img src={ArrowRight} alt='' />
              </button>
            </div>)}
        </Mutation>)
    )
  };
}

export default NewMessage;


// WEBPACK FOOTER //
// ./src/pages/chat/chat-messages/new-message/NewMessage.jsx